import { formatPrice } from '@ynap/intl-formatters'
import getFormattedDate from 'app/utils/getFormattedDate'

export default function getStoreCredit(state) {
    const { storeCredit, storeCreditError, isFetchingStoreCredit, locale } = state
    const { credit, transactions } = storeCredit

    return {
        credit: credit
            ? formatPrice(
                  credit.balance.value.amount / credit.balance.value.divisor,
                  credit.balance.currency.label,
                  locale.id
              )
            : undefined,
        transactions: transactions
            ? transactions.map((transaction) => {
                  const formattedPrice = formatPrice(
                      transaction.amount.value.amount / transaction.amount.value.divisor,
                      transaction.amount.currency.label,
                      locale.id
                  )

                  return {
                      amount: transaction.amount.value.amount >= 0 ? `+${formattedPrice}` : formattedPrice,
                      date: getFormattedDate(transaction.date, locale.id),
                      type: transaction.type,
                      credit: transaction.amount.value.amount >= 0 ? true : false,
                  }
              })
            : undefined,
        storeCreditError,
        isFetchingStoreCredit,
    }
}
